import { QuestionUsersComponent } from './question-users.component';

export default angular
  .module('sfMobile.components.question-users', [])
  .component('questionUsers', QuestionUsersComponent).name;
